import moment from "../../../node_modules/moment/moment";

export const disabledFutureDate = (current) => {
  const dateNow = moment();
  const currentDate = moment(current);
  const isAfter = currentDate.isAfter(dateNow);
  return isAfter;
};
